import AppealDisplay from "components/assetAppealDetails/AppealDisplay";
import FileViewer from "components/file-components/fileViewer2";
import Loading from "components/Loading";
import { AddAppealHigherCourtPopup } from "components/pop-up/AddAppealHigherCourtPopup";
import { AddLowerCourtPopup } from "components/pop-up/AddAppealLowerCourtPopup";
import AssetAppealProsecutorReassignPopup from "components/pop-up/AppealProsecutorAssignmentPopup";
import { CreateAppealRequestPopup } from "components/pop-up/AppealRequest";
import { AssetAppealRespondBackPopup } from "components/pop-up/AssetAppealRespondBackPopup";
import RespondantAssetAppealRequest from "components/pop-up/RespondantAssetAppealRequest";
import ProsecutorResponsePopup from "components/pop-up/RespondentAppealProsecutorResponsePopup";
import RespondentAppealDisplay from "components/respondentAppeal/RespondentAppealDispla";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  updateAssetAppeal,
  updateRespondentAssetAppeal,
} from "services/assetAppealService";
import { getChildUserOrgDetails } from "services/assetRecoveryService";
import {
  AppealRequestForwardingStatusEnum,
  Asset,
  AssetAppeal,
  AssetAppealRequestActionStatusEnum,
} from "types";

export default function RespopndentAssetAppealDetails({
  appeal,
  loading,
  isAssetCoordinator,
  isAssetProsecutor,
  isAssetRegistrar,
  setAppeal,
  setActiveTab,
  fileRowProps,
}: {
  appeal: AssetAppeal | null;
  loading: boolean;
  isAssetCoordinator: boolean;
  isAssetProsecutor: boolean;
  setAppeal: React.Dispatch<React.SetStateAction<AssetAppeal | null>>;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  fileRowProps?: any;
  isAssetRegistrar: boolean;
}) {
  const [isApproving, setIsApproving] = useState(false);
  const [isForwarding, setIsForwarding] = useState(false);

  const [isTransfering, setIsTransferring] = useState(false);
  const [isAddLowerPopup, setIsAddLowerCourtPopup] = useState(false);
  const [isAddHigerPopup, setIsAddLoweerCourtPopup] = useState(false);
  const [isProsecutorReassignPopupOpen, setIsProsecutorReassignPopupOpen] =
    useState(false);
  const [isProsecutorResponsePopop, setIsAddProsecutorResponse] =
    useState(false);
  const [isAppealPopupOpen, setIsAppealPopupOpen] = useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: null });
  const hasLowerCourtData = Boolean(
    appeal?.lower_court_level ||
    appeal?.lower_court_name ||
    appeal?.lower_court_type ||
    appeal?.lower_registration_date ||
    appeal?.lower_registration_number,
  );
  const [isRespondantPopupOpen, setIsRespondantPopupOpen] = useState(false);
  const hasProsecutorResponseData = Boolean(
    // appeal?.date_submitted ||
    appeal?.appeal_response_summary ||
    (appeal?.prosecutor_response_file &&
      appeal?.prosecutor_response_file.length > 0),
  );
  const hasHigherCourtData = Boolean(
    appeal?.higher_court_hearing_date ||
    appeal?.higher_court_level ||
    appeal?.higher_court_name ||
    appeal?.higher_court_type ||
    appeal?.registration_number ||
    appeal?.registration_date ||
    appeal?.court_appeal_number ||
    appeal?.court_summons ||
    appeal?.opening_date ||
    appeal?.first_hearidng_date,
  );

  const hasProsecutor = Boolean(
    appeal?.assigned_prosecutor_id || appeal?.assigned_prosecutor_name,
  );
  const [isRespondBackAssetAppealOpen, setIsRespondBackAssetAppealOpen] =
    useState(false);
  const { showTooltip } = useTooltip();
  const { t } = useTranslation();

  const fetchAdminUnits = async (adminUnitId: string, orgUnitId?: string) => {
    try {
      const data = await getChildUserOrgDetails(adminUnitId, orgUnitId || "");
      return data?.admin_unit?.parent_unit;
    } catch (error) {
      console.error("Error fetching admin units:", error);
      showTooltip(
        t("failed_to_load_destination_units", {
          defaultValue: "Failed to load destination units",
        }),
        "error",
      );
    }
  };
  const handleAppealApproval = async () => {
    setIsApproving(true);

    const formData = new FormData();
    formData.append(
      "action_status",
      AssetAppealRequestActionStatusEnum.APPEAL_APPROVED,
    );
    formData.append(
      "forwarding_status",
      AppealRequestForwardingStatusEnum.FORWARDED_TO_REGISTRAR,
    );
    let response;
    try {
      if (appeal?.appeal_type === "appeal_by_respondant") {
        response = await updateRespondentAssetAppeal(
          appeal?.id as string,
          formData,
        );
      } else response = await updateAssetAppeal(appeal?.id as string, formData);
      if (response) {
        if (appeal?.appeal_type === "appeal_by_respondant") {
          setAppeal(response);
        } else setAppeal(response?.appeal);
        showTooltip(
          t("asset_appeal_request_approved_successfully", {
            defaultValue: "Asset Appeal Request Approved successfully",
          }),
          "success",
        );
        setActiveTab("Appeal");
      }
    } catch (error) {
      console.error("Error approving prohibition:", error);
      showTooltip(t("failed_to_approve_prohibition"), "error");
    } finally {
      setIsApproving(false);
    }
  };

  const { loginData } = useAuth();
  const handleSubmitToCourt = async () => {
    setIsTransferring(true);

    const formData = new FormData();

    try {
      const adminUnit = await fetchAdminUnits(
        loginData?.admin_unit?.toString() as string,
        loginData?.org_unit?.toString() as string,
      );

      formData.append(
        "action_status",
        AssetAppealRequestActionStatusEnum.APPEAL_SUBMITTED_TO_COURT,
      );
      formData.append(
        "forwarding_status",
        AppealRequestForwardingStatusEnum.FORWARDED_TO_HIGHER_COORDINATOR,
      );

      if (adminUnit) {
        formData.append("admin_unit", adminUnit);
      }

      const response = await updateAssetAppeal(appeal?.id as string, formData);

      if (response) {
        setAppeal(response?.appeal);
        showTooltip(
          t("asset_appeal_request_submitted_successfully", {
            defaultValue: "Asset Appeal Request Submitted successfully",
          }),
          "success",
        );
        setActiveTab("Appeal");
        setIsTransferring(false);
      }
    } catch (error) {
      console.error("Error submitting:", error);
      showTooltip(
        t("failed_to_submit", { defaultValue: "Failed to submit." }),
        "error",
      );
    } finally {
      setIsTransferring(false);
    }
  };

  const handleProsecutorResponseForwardToCoordinator = async () => {
    try {
      setIsForwarding(true);

      const formData = new FormData();

      formData.append("forwarding_status", "Forwarded To Coordinator");
      if (
        appeal?.action_status ===
        AssetAppealRequestActionStatusEnum?.APPEAL_RESPONDED
      ) {
        formData.append(
          "action_status",
          AssetAppealRequestActionStatusEnum?.APPEAL_UPDATED,
        );
      }
      const response = await updateRespondentAssetAppeal(
        appeal?.id as string,
        formData,
      );
      showTooltip(t("successfully_forwarded"), "success");

      if (response) {
        setAppeal(response?.respondant ?? response);
        setActiveTab?.("Appeal");
      }
    } catch (error) {
      console.error("Error forwarding to coordinator:", error);
      showTooltip(t("failed_to_forward_to_coordinator"), "error");
    } finally {
      setIsForwarding(false);
    }
  };
  const handleRespondentAppealForwardToCoordinator = async () => {
    try {
      setIsForwarding(true);

      const formData = new FormData();

      formData.append("forwarding_status", "Forwarded To Coordinator");
      if (
        appeal?.action_status ===
        AssetAppealRequestActionStatusEnum?.APPEAL_RESPONDED
      ) {
        formData.append(
          "action_status",
          AssetAppealRequestActionStatusEnum?.APPEAL_UPDATED,
        );
      }
      const response = await updateRespondentAssetAppeal(
        appeal?.id as string,
        formData,
      );
      showTooltip(t("successfully_forwarded"), "success");

      if (response) {
        setAppeal(response.respondant ?? response);
        setActiveTab?.("Appeal");
      }
    } catch (error) {
      console.error("Error forwarding to coordinator:", error);
      showTooltip(t("failed_to_forward_to_coordinator"), "error");
    } finally {
      setIsForwarding(false);
    }
  };
  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      {loading ? (
        <Loading />
      ) : (
        <RespondentAppealDisplay
          appeal={appeal as AssetAppeal}
          fileRowProps={fileRowProps}
          isAssetProsecutor={isAssetProsecutor}
          onEditClick={() => setIsRespondantPopupOpen(true)}
          handleAppealApproval={handleAppealApproval}
          isAssetCoordinator={isAssetCoordinator}
          setIsRespondBackAssetAppealOpen={setIsRespondBackAssetAppealOpen}
          isApproving={isApproving}
          setIsAddLowerCourtPopup={setIsAddLowerCourtPopup}
          hasLowerCourtData={hasLowerCourtData}
          hasHigherCourtData={hasHigherCourtData}
          handleSubmitToCourt={handleSubmitToCourt}
          isTransfering={isTransfering}
          setIsAddLoweerCourtPopup={setIsAddLoweerCourtPopup}
          setIsProsecutorReassignPopupOpen={setIsProsecutorReassignPopupOpen}
          hasProsecutor={hasProsecutor}
          setIsAppealPopupOpen={setIsAppealPopupOpen}
          isAssetRegistrar={isAssetRegistrar}
          handleRespondentAppealForwardToCoordinator={
            handleRespondentAppealForwardToCoordinator
          }
          isForwarding={isForwarding}
          hasProsecutorResponseData={hasProsecutorResponseData}
          setIsAddProsecutorResponse={setIsAddProsecutorResponse}
          handleProsecutorResponseForwardToCoordinator={
            handleProsecutorResponseForwardToCoordinator
          }
        />
      )}

      <AssetAppealRespondBackPopup
        appealId={appeal?.id as string}
        appeal={appeal as AssetAppeal}
        isOpen={isRespondBackAssetAppealOpen}
        onClose={() => setIsRespondBackAssetAppealOpen(false)}
        onNewDataAdded={setAppeal}
        setActiveTab={setActiveTab}
        type="appeal-respondent"
      />
      <AddLowerCourtPopup
        appealType="respondant"
        appealId={appeal?.id as string}
        isOpen={isAddLowerPopup}
        onClose={() => setIsAddLowerCourtPopup(false)}
        existingData={{}}
        key={appeal?.id}
        onSuccess={setAppeal}
        setActiveTab={setActiveTab}
      />
      <AddAppealHigherCourtPopup
        appealId={appeal?.id as string}
        appealType="respondant"
        isOpen={isAddHigerPopup}
        onClose={() => setIsAddLoweerCourtPopup(false)}
        existingData={{}}
        onSuccess={setAppeal}
        setActiveTab={setActiveTab}
      />
      <AssetAppealProsecutorReassignPopup
        isOpen={isProsecutorReassignPopupOpen}
        onClose={() => setIsProsecutorReassignPopupOpen(false)}
        appeal={appeal as AssetAppeal}
        assignedProsecutor=""
        onProsecutorUpdated={setAppeal}
      />

      <CreateAppealRequestPopup
        referralId={appeal?.asset_referral?.id as string}
        data={isAppealPopupOpen.data}
        isOpen={isAppealPopupOpen.open}
        onClose={() => setIsAppealPopupOpen({ open: false, data: null })}
        existingData={{
          appeal_claim_summary: appeal?.appeal_claim_summary,
          asset: appeal?.assets?.[0] ?? appeal?.asset,
          action_status:
            appeal?.action_status as AssetAppealRequestActionStatusEnum,
        }}
        setAppeal={setAppeal}
        setActiveTab={setActiveTab}
        // onSuccess={}
      />
      <RespondantAssetAppealRequest
        isOpen={isRespondantPopupOpen}
        onClose={() => setIsRespondantPopupOpen(false)}
        asset={appeal?.assets as Asset[]}
        prohabition_request_court_registration_number={
          appeal?.asset_referral
            ?.prohabition_request_court_registration_number as string
        }
        asset_referral={appeal?.asset_referral?.id as string}
        onSuccess={setAppeal}
        // Edit mode props
        isEdit={true}
        appealData={appeal}
        appealId={appeal?.id}
        setAppeal={setAppeal}
      />
      <ProsecutorResponsePopup
        isOpen={isProsecutorResponsePopop}
        onClose={() => setIsAddProsecutorResponse(false)}
        appealId={appeal?.id}
        setAppeal={setAppeal}
      />
    </div>
  );
}
